<script>
    import SortableTable from '../SortableTable.svelte';
    import {tables} from '../../lib/tables';
    import {forms} from '../../lib/forms';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';

    import serviceRecommendationModel from '../../Models/serviceRecommendationModel';

    export let assessment_model;
    let assessment = assessment_model.store;

    let modal;

    let collapsed = true;

    let suggested_services = [];

    let service_recommendations = serviceRecommendationModel.getServiceRecommendationList();

    async function get_recommendations(assessment) {
        let promises = [];
        for (let category of assessment.assessment_type_data.categories) {
            for (let subcategory of category.subcategories) {
                for (let question of subcategory.controls) {
                    if (question.tag_mapping) {
                        for (let [tag_id, mapping] of Object.entries(question.tag_mapping)) {
                            if (assessment_model.getTag(question.id, tag_id).value == 1){
                                for (let map of mapping) {
                                    if (map.startsWith("serviceRecommendation")) {
                                        promises.push(serviceRecommendationModel.getServiceRecommendation(map))
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let settled_promises = await Promise.allSettled(promises);
        let results = [];
        for (let p of settled_promises) {
            if (p.status == "fulfilled") {
                results.push(p.value);
            }
        }

        suggested_services = results;
    }

    function addServiceRecommendation() {
        addFormModal({
            fields: forms['serviceRecommendation']
        }).then((formData) => {
            assessment_model.addServiceRecommendation(formData)
        })
    }

    function updateServiceRecommendation(recommendation) {
        addFormModal({
            fields: forms['serviceRecommendation'],
            data: recommendation
        }).then( formData => {
            assessment_model.updateServiceRecommendation(formData)
        })
    }

    function deleteServiceRecommendation(recommendation) {
        assessment_model.deleteServiceRecommendation(recommendation);
    }

    function doAddFromTemplate(service_recommendation) {
        service_recommendation.template_id = service_recommendation._id,

        service_recommendation._id = undefined;
        service_recommendation._rev = undefined;
        assessment_model.addServiceRecommendation(service_recommendation);
    }

    function addRecommendationFromTemplate() {
        return new Promise((resolve, reject) => {
            modal = {
                cancelAction: reject,
                saveAction: resolve
            }
        }).then((recommendation_id) => {
            serviceRecommendationModel.getServiceRecommendation(recommendation_id).then(doAddFromTemplate)
        }).catch(() => {
            null
        }).finally(() => {
            modal = undefined;
        })
    }

    $: get_recommendations($assessment);
</script>
<h2 class="title is-2">Report</h2>
<SortableTable sortFields={tables['serviceRecommendations']} tableData={$assessment.service_recommendations} tableClass="ServiceTable">
    <div slot="filterActions">
        {#if $assessment.service_recommendations.length < 4}
            <button class="button is-success" on:click={addServiceRecommendation}>Add Service Recommendation</button>
        {/if}
    </div>
    <div slot="rowActions" let:row={recommendation}>
        <div class="buttons is-centered">
            <button class="button is-danger" on:click={() => deleteServiceRecommendation(recommendation)}>Delete</button>
            <button class="button is-link" on:click={() => updateServiceRecommendation(recommendation)}>Edit</button>
        </div>
    </div>
    <div slot="footerActions">
        <div class="buttons is-right">
            {#if $assessment.service_recommendations.length < 4}
                <button class="button is-primary" on:click={addRecommendationFromTemplate}>Add From Template</button>
            {/if}
        </div>
    </div>
</SortableTable>

{#if $assessment.service_recommendations.length < 4 && suggested_services.length}
<h3 class="title is-4 pointer" on:click={() => collapsed = !collapsed}>{collapsed ? "[+]" : "[-]"} Mapped Services</h3>
    {#if !collapsed}
        <SortableTable sortFields={tables['serviceRecommendations']} tableData={suggested_services} tableClass="ServiceTable">
            <div slot="rowActions" let:row={service}>
                <button class="button is-link" on:click={() => doAddFromTemplate(service)}>Add To Report</button>
            </div>
        </SortableTable>
    {/if}
{/if}

{#if modal}
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card is-fullwidth">
            <header class="modal-card-head">
            <p class="modal-card-title">Create from Template</p>
                <button class="delete" aria-label="close" on:click={modal.cancelAction}></button>
            </header>
            <section class="modal-card-body">
                <SortableTable sortFields={tables["serviceRecommendations"]} tableData={$service_recommendations} tableClass="ServiceTable">
                    <div slot="rowActions" let:row={recommendation}>
                        <div class="button is-success" on:click={() => modal.saveAction(recommendation._id)}>Select Recommendation</div>
                    </div>
                </SortableTable>
            </section>
            <footer class="modal-card-foot has-text-right">
                <button class="button is-pulled-right" on:click={modal.cancelAction}>Close</button>
            </footer>
        </div>
    </div>
{/if}